import { render, staticRenderFns } from "./RegEbs.vue?vue&type=template&id=1fa062cf&"
import script from "./RegEbs.vue?vue&type=script&lang=js&"
export * from "./RegEbs.vue?vue&type=script&lang=js&"
import style0 from "./RegEbs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports